/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {ReportScheduleListPageComponent} from './report-schedule-list-page.component';

@Component({
  standalone: true,
  imports: [ReportScheduleListPageComponent],
  selector: 'adn-report-schedule-route-page',
  template: `
    <adn-report-schedule-list-page
      [readOnly]="readOnly">
    </adn-report-schedule-list-page>
  `
})
export class ReportScheduleRoutePageComponent {
  @Input() readOnly = false;
}
